export default "__VITE_ASSET__CKQKxlTK__"